<template>
  <div id="app" :class="layout_class + '' + loader_class">
    <!-- <component :is="layout"> -->
      <router-view/>
    <!-- </componenntes de manejo de errores
    -->
    <div class="loader" v-if="showLoader == true">
      <img src="@/assets/images/loader/loader.svg" alt="">
    </div>
  </div>
</template>

<script>
  import axios from 'axios';
  const default_layout = 'default';
  const default_class_layout = '';

  export default {
    name: 'app',
    data() {
      return {
        authenticated: false
      }
    },
    computed: {
      layout() {
        return `${(this.$route.meta.layout || default_layout)}-layout`;
      },
      layout_class() {
        return `${(this.$route.name || default_class_layout)}`;
      },
      loader_class(){
        return this.$store.state.showLoader == true ? 'stop-scrolling' : ''
      },
      showLoader(){
        return this.$store.state.showLoader;
      }
    },
    created(){
      axios.defaults.baseURL = process.env.VUE_APP_API_ENDPOINT;
    }
  }
</script>

<style lang="scss">
  @import 'assets/sass/app.scss';
</style>
